import React, { useState, useEffect } from 'react';
import './FlashSale.css';
import { motion } from 'framer-motion';

const FlashSale = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 12,
    minutes: 45,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return { hours, minutes, seconds };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatNumber = (num) => num.toString().padStart(2, '0');

  return (
    <section className="flash-sale" id="sale">
      <div className="flash-sale-container">
        <div className="section-header">
          <motion.div 
            className="section-label"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            FLASH SALE
          </motion.div>
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            LIMITED OFFER
          </motion.h2>
        </div>

        <div className="flash-content-wrapper">
          <motion.div 
            className="flash-left"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="flash-img-wrapper">
            <img 
              src="https://blacksalt.ascentbw.com/Images/Home/Hero1.webp" 
              alt="Sale Fashion" 
              className="flash-main-img"
            />
            <div className="flash-badge">LIMITED</div>
          </div>
        </motion.div>

        <motion.div 
          className="flash-right"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="flash-content-bg">
            <img 
              src="https://blacksalt.ascentbw.com/Images/Home/Hero2.webp" 
              alt="Sale Content Background" 
              className="flash-bg-img"
            />
            <div className="flash-overlay">
              <motion.span 
                className="flash-label"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                SPECIAL OFFER
              </motion.span>
              <motion.h2 
                className="flash-title"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                FLASH <br /> <span>SALE</span>
              </motion.h2>
              <motion.div 
                className="flash-discount"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.5 }}
              >
                UP TO 50% OFF
              </motion.div>

              <div className="countdown-timer">
                <div className="time-block">
                  <span className="time-val">{formatNumber(timeLeft.hours)}</span>
                  <span className="time-label">HRS</span>
                </div>
                <span className="separator">:</span>
                <div className="time-block">
                  <span className="time-val">{formatNumber(timeLeft.minutes)}</span>
                  <span className="time-label">MIN</span>
                </div>
                <span className="separator">:</span>
                <div className="time-block">
                  <span className="time-val">{formatNumber(timeLeft.seconds)}</span>
                  <span className="time-label">SEC</span>
                </div>
              </div>

              <motion.button 
                className="flash-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                SHOP THE SALE
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
  );
};

export default FlashSale;
